import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Typography, Grid, useTheme } from '@material-ui/core';


const StyledCheckBox = withStyles((theme) => ({
  root: {
    color: theme.palette.KenColors.neutral60,
    '&$checked': {
      color: theme.palette.KenColors.primary,
    },
  },
  checked: {},
}))((props) => <Checkbox color="default" {...props} />);

export default function KenCheckbox(props) {
  const { disabled, name, label, value, onChange, labelProps } = props;
  const theme = useTheme();
  return (
    <FormGroup>
      <Grid container alignItems="center">
        <FormControlLabel
          control={
            <StyledCheckBox
              disabled={disabled}
              checked={value}
              onChange={onChange}
              name={name}
              Component-root={{
                style: { color: theme.palette.KenColors.secondaryPeach2 },
              }}
              style={
                disabled
                  ? {
                      color: theme.palette.KenColors.neutral40,
                      marginRight: '-20px',
                    }
                  : { color: '', marginRight: '-20px' }
              }
            />
          }
        />
        <Typography
          style={{
            fontSize: 12,
            color: theme.palette.KenColors.neutral100,
          }}
          {...labelProps}
        >
          {label}
        </Typography>
      </Grid>
    </FormGroup>
  );
}
